import "./ElectionProgram.module.css";
import Header from "@/reusable_sections/Header";
import ServicesGrid from "./sections/ServicesGrid";
import Footer from "@/reusable_sections/Footer";
export default function ElectionProgramPage() {
  return <div>
      <Header />
      <ServicesGrid />
      <Footer />
    </div>;
}